import React, { FC, useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Col, Row } from 'react-bootstrap';
import { NavitiaSearchBox, NavitiaSuggestions, SimulatorSearchProps, TranslationItem } from '@mappr/react-lib';
import { AutocompleteInput } from './AutocompleteInput';
import i18n from '../../i18n';

interface NavitiaSuggestionsWrapperProps {
  onSearch: (from: object, to: object) => void;
  onUpdate: (value: string) => void;

}

interface Coord {
  embedded_type: string,
  coord: {
    lat: string
    lon: string
  }
  id: string,
  name: string,
  quality: string,
  stop_area: any
}


const NavitiaSuggestionsWrapper: React.FC<NavitiaSuggestionsWrapperProps> = ({ onUpdate }) => {
  const { t } = useTranslation();
  const [fromItem, setFormItem] = useState<Coord | undefined>(undefined);
  const [toItem, setToItem] = useState<Coord | undefined>(undefined);
  const [calcUrl, setCalcUrl] = useState('https://carte.societedugrandparis.fr/');
  const handleSwitchButtonClick = useCallback(() => {
    setFormItem(toItem);
    setToItem(fromItem);
  }, [fromItem, toItem]);

  useEffect(() => {
    let from = `${fromItem?.coord.lon};${fromItem?.coord.lat}`;
    let to = `${toItem?.coord.lon};${toItem?.coord.lat}`;
    if (fromItem?.embedded_type === 'stop_area') {
      from = fromItem.id;
    }
    if (toItem?.embedded_type === 'stop_area') {
      to = toItem.id;
    }
    if (fromItem && toItem) {
      setCalcUrl(`https://carte.societedugrandparis.fr/fr/simulator#map=10.29/48.8693/2.399&page=1&journey="from=${from}%26to=${to}"`);
    }
  }, [fromItem, toItem]);

  const handelClick = useCallback((e: React.MouseEvent<HTMLElement>) => {
    window.parent.postMessage({
      'sgp_mapurl': calcUrl
    }, '*');
    e.preventDefault();
    return false;
  }, [calcUrl]);

  return <NavitiaSuggestions>
    {({ suggestions }, { onSelect }) => {
      return (
        <>
          <Row className="title"> <Col>{t('simulator.title')}</Col></Row>
          <Row>
            <Col md={5} sm={10} xs={10} className={'pe-0'}>
              <AutocompleteInput
                onUpdate={onUpdate}
                onSelect={onSelect}
                suggestions={suggestions}
                item={fromItem}
                setItem={setFormItem}
                label={t('simulator.fromLabel')}
                point={'start'}
                placeholder={t(
                  'simulator.fromPlaceholder'
                )}
              />
            </Col>
            <Col className={'switch-button'} md={2} sm={12} xs={12}>
              <span onClick={handleSwitchButtonClick} />
            </Col>
            <Col md={5} sm={10} xs={10} className={'pe-0'}>
              <AutocompleteInput
                onUpdate={onUpdate}
                onSelect={onSelect}
                suggestions={suggestions}
                item={toItem}
                setItem={setToItem}
                label={t('simulator.toLabel')}
                point={'end'}
                placeholder={t(
                  'simulator.toPlaceholder'
                )}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12} sm={10} xs={10}>
              <Button
                href={calcUrl}
                className={'nav-link btn-calculate cursor-pointer'} rel="noreferrer"
                onClick={handelClick}
              >
                {t('simulator.calculate')}
              </Button>
            </Col>
          </Row>
        </>
      );
    }}
  </NavitiaSuggestions>;
};


export const SimulatorSearch: FC<{ project?: SimulatorSearchProps }> = ({ project }) => {

  useEffect(() => {
    if (project && project.translations) {
      Object.entries(project.translations).forEach(
        ([lang, resources]) => {
          const pt: any = {};
          resources.forEach((_) => {
            pt[_.key as keyof TranslationItem] = _.value;
          });
          i18n.addResourceBundle(lang, 'project', pt);
        }
      );
    }
  }, [project]);

  return (
    <NavitiaSearchBox addressLimit={5} stopAreaLimit={3}>
      {(_, { onSearch, onUpdate }) => <NavitiaSuggestionsWrapper onSearch={onSearch} onUpdate={onUpdate} />}
    </NavitiaSearchBox>
  );
};
